import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["composer"]

  reply({ params: { mention } }) {
    const composer = this.composerTarget

    composer.focus({ preventScroll: true })
    composer.scrollIntoView({ behavior: "smooth", block: "center" })

    const mentions = composer.value.match(/@\w+/g) || []
    if (mentions.includes(mention)) return

    const cursor = composer.selectionStart ?? composer.value.length
    const before = composer.value.slice(0, cursor)
    const after = composer.value.slice(cursor)
    const leadingSpace = before.length > 0 && !/\s$/.test(before) ? " " : ""
    const trailingSpace = after.length === 0 || !/^\s/.test(after) ? " " : ""
    const insertion = `${leadingSpace}${mention}${trailingSpace}`

    composer.value = `${before}${insertion}${after}`
    composer.dispatchEvent(new Event("input", { bubbles: true }))

    const existingSpaceLength = trailingSpace === "" && /^\s/.test(after) ? 1 : 0
    const caret = before.length + insertion.length + existingSpaceLength
    composer.setSelectionRange(caret, caret)
  }
}
